// This is the flow that's stored in the onboarding file in dynamodb

export enum Flow {
  BUSINESS_ABN_AMRO = 'BUSINESS_ABN_AMRO', // productType = TIKKIE_ALL, hasAbnAccount = true
  BUSINESS_CDD = 'BUSINESS_CDD', // productType = TIKKIE_ALL, hasAbnAccount = false, and cddOnboarding = true
  BUSINESS_INVITE = 'BUSINESS_INVITE', // productType = TIKKIE_ALL, hasAbnAccount = false, and cddOnboarding = false
  RECYCLING_INVITE = 'RECYCLING_INVITE', // productType = RECYCLING
  CASHBACK_INVITE = 'CASHBACK_INVITE', // productType = CASHBACK
}
